module.exports = __webpack_public_path__ + "img/publish-3.ce23d571.svg";